import firebase from "firebase/app";

var project = {};

project.RESET_DATA = -1;

project.GetUrlVars = function () {
  let vars = [], max = 0, hash = "", array = "";
  let url = window.location.search;

  //?を取り除くため、1から始める。複数のクエリ文字列に対応するため、&で区切る
  hash = url.slice(1).split('&');
  max = hash.length;
  for (let i = 0; i < max; i++) {
    array = hash[i].split('=');    //keyと値に分割。
    vars.push(array[0]);          //末尾にクエリ文字列のkeyを挿入。
    vars[array[0]] = decodeURIComponent(array[1]);    //先ほど確保したkeyに、値を代入。
  }

  return vars;
}

//{}かどうかの判定
project.IsEmpty = function(obj){
  return !Object.keys(obj).length;
}

project.PostApi = async function (handler, json ,isAuth) {
  isAuth = isAuth || false;

  return new Promise(
    async(resolve, reject)=> {
          let req = new XMLHttpRequest();

          req.onload =  ()=> {
              if (req.readyState == 4 && req.status == 200) {
                  let json = "";
                  if (req.response) {
                    json = req.response ;
                      if (typeof json != 'object') {
                        json = JSON.parse(req.response);
                      }

                      if (json["error"] != null) {
                        reject(new Error(json["error"]));
                      }                      
                  }
                  resolve(json);
              } else {
                  reject(new Error(req.statusText));
              }
          };

          //process.env.VUE_APP_API_ORIGINはデバッグ時使用
          let posturl = process.env.VUE_APP_API_ORIGIN || "";

          posturl += handler + '?' + (new Date()).getTime() ;          

          req.open('POST', posturl);

          req.responseType = 'json';
          req.setRequestHeader("Content-Type", "application/json");

          let token='';

          if (isAuth == true){
            await firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
              //req.setRequestHeader("Authorization", "Bearer " + idToken);
              token = idToken;
  
            }).catch(function(err) {
              console.log('Error Auth', err);
              reject(new Error('認証エラー'));
            });
  
            req.setRequestHeader("token", token);
          }

          if (json == null) {
              req.send(null);
          }
          else {
              req.send(JSON.stringify(json));
          }            
          
      }
  );
};

/**
 * 処理中（くるくる）の開始/終了
 * @param {loadingFlag} true：開始 false:終了
*/
project.SetLoading = function (loadingFlag) {

  let divid = "divloading";
  if (loadingFlag) {

      //既に表示されている場合は無視
      if (document.getElementById(divid) != null) {
          return ;
      }

      let div = document.createElement('div');
      div.id = divid;
      div.innerHTML =
          "<div class=\"loader-bg\">" +
          "</div>" +
          "<div class=\"loader\">" +
          "</div>"
      ;
      document.body.appendChild(div);
    }
  else {

      let div = document.getElementById(divid);
      if (div != null) {
          document.body.removeChild(div);
      }
  }

};

export default project;